import {useNavigate} from "react-router";
import {useEffect, useState} from "react";
import {useAuthStore} from "../../../store/auth.store";
import {PartnerApi} from "../../../api/partner.api";
import {useTranslation} from "../../../hooks/useTranslation";

export default function UserNewForm({handleClose, callback}) {
    const { t } = useTranslation();
    const [error, setError] = useState(null);

    const token = useAuthStore((state) => state.token);

    const createUser = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        setError(null);
        const result = PartnerApi.userAdd({
            token,
            data: {
                firstName: formData.get("firstName"),
                lastName: formData.get("lastName"),
                email: formData.get("email"),
            }
        });
        result.then((result) => {
            if ("error" in result) {
                setError(result.error);
                return;
            }

            handleClose();
            if (callback) {
                callback();
            }
        });
        return false;
    }

    return (
        <form onSubmit={(e) => createUser(e)}>

            {error && (
                <p className="alert alert-danger">{error}</p>
            )}

            <div className="mb-10">
                <label
                    className="required form-label">{t("users.firstName")}</label>
                <input type="text"
                       name="firstName"
                       required={true}
                       className="form-control form-control-solid"/>
            </div>

            <div className="mb-10">
                <label
                    className="required form-label">{t("users.lastName")}</label>
                <input type="text"
                       name="lastName"
                       required={true}
                       className="form-control form-control-solid"/>
            </div>


            <div className="mb-10">
                <label
                    className="required form-label">{t("users.email")}</label>
                <input type="email"
                       name="email"
                       required={true}
                       className="form-control form-control-solid"/>
            </div>

            <button type="submit" className="btn btn-primary">{t("users.addPerson")}</button>
        </form>
    );
}